import { IDexTrade } from '@kattana-io/common';
import { useState, useEffect } from 'react';
import { KattanaAPI } from '../../store/createStore';

/**
 * Hook for fetching
 * @param account
 * @param protocol
 */
const useWalletTrades = (
  account: string | null | undefined,
  network: string,
  address: string
) => {
  const [swaps, setSwaps] = useState<IDexTrade[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (account && address) {
      setLoading(true);
      const controller = new AbortController();

      KattanaAPI.walletTrades(account, address, network, controller)
        .then((response: IDexTrade[] | null) => {
          setSwaps(response ? response : []);
          setLoading(false);
        })
        .catch((err: any) => {
          console.warn(err);
          setSwaps([]);
          setLoading(false);
        });

      return () => {
        controller.abort();
      };
    } else {
      setSwaps([]);
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [account, network]);

  return {
    swaps,
    loading,
  };
};

export default useWalletTrades;
